/**
 * v4.8.1 — Curated Demo Mode placeholder.
 *
 * Rendered when a user direct-URLs to a non-curated surface while Master
 * Demo Mode is active. Calm, intentional, premium — never an error.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { OperationalShell } from "../components/OperationalShell";

const DemoUnavailable = () => {
    const { t } = useTranslation();
    const nav = useNavigate();
    return (
        <OperationalShell breadcrumb={[{ label: t("ob.demo_unavailable.eyebrow") }]}>
            <div
                data-testid="demo-unavailable-page"
                className="flex flex-col items-center justify-center text-center"
                style={{ minHeight: "60vh", padding: "4rem 1.5rem" }}
            >
                <div
                    className="flex items-center justify-center mb-8"
                    style={{
                        width: 84, height: 84,
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, rgba(16,185,129,0.15), rgba(245,158,11,0.10))",
                        border: "1px solid rgba(167, 243, 208, 0.25)",
                        boxShadow: "0 0 40px rgba(16, 185, 129, 0.18)",
                    }}
                >
                    <ShieldCheck
                        size={36}
                        strokeWidth={1.5}
                        style={{ color: "#A7F3D0" }}
                    />
                </div>

                <p
                    className="ob-eyebrow mb-4"
                    data-testid="demo-unavailable-eyebrow"
                >
                    {t("ob.demo_unavailable.eyebrow")}
                </p>

                <h1
                    className="text-4xl sm:text-5xl mb-5"
                    style={{ color: "var(--ob-text-primary)", maxWidth: "28ch" }}
                    data-testid="demo-unavailable-title"
                >
                    {t("ob.demo_unavailable.title")}
                </h1>

                <p
                    className="text-base mb-10"
                    style={{
                        color: "var(--ob-text-secondary)",
                        maxWidth: "52ch",
                        lineHeight: 1.65,
                    }}
                    data-testid="demo-unavailable-subtitle"
                >
                    {t("ob.demo_unavailable.subtitle")}
                </p>

                <button
                    type="button"
                    onClick={() => nav("/operational-base")}
                    data-testid="demo-unavailable-return-btn"
                    className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm transition-transform active:scale-95"
                    style={{
                        color: "#0F172A",
                        background: "linear-gradient(135deg, #A7F3D0, #6EE7B7)",
                        border: "1px solid rgba(16, 185, 129, 0.4)",
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 500,
                        boxShadow: "0 6px 24px rgba(16, 185, 129, 0.25)",
                    }}
                >
                    <ArrowLeft size={14} strokeWidth={2} />
                    {t("ob.demo_unavailable.return")}
                </button>

                <p
                    className="text-[11px] uppercase tracking-wider mt-12"
                    style={{ color: "var(--ob-text-tertiary)" }}
                    data-testid="demo-unavailable-persona"
                >
                    {t("ob.demo_unavailable.persona")}
                </p>
            </div>
        </OperationalShell>
    );
};

export default DemoUnavailable;
